<div class="mat-elevation-z2">
  <table mat-table [dataSource]="data" class="full-width-table" aria-label="Elements">
    <!-- event Column -->
    <ng-container matColumnDef="event">
      <th mat-header-cell *matHeaderCellDef>EVENT</th>
      <td mat-cell *matCellDef="let row">{{ row.event }}</td>
    </ng-container>

    <!-- user Column -->
    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef>USER</th>
      <td mat-cell *matCellDef="let row">{{ row.user }}</td>
    </ng-container>

    <!-- timestamp Column -->
    <ng-container matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef>TIMESTAMP</th>
      <td mat-cell *matCellDef="let row">{{ row.timestamp | formatDateTime }}</td>
    </ng-container>

    <!-- remarks Column -->
    <ng-container matColumnDef="remarks">
      <th mat-header-cell *matHeaderCellDef>COMMENT/REMARK</th>
      <td mat-cell *matCellDef="let row">{{ row.remarks ?? '-' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
